import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { doc, getDoc, setDoc } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCpHumZfoMR-keQmntQjh5FPYP20YOybGA",
  authDomain: "pokerbank-b4bdc.firebaseapp.com",
  projectId: "pokerbank-b4bdc",
  storageBucket: "pokerbank-b4bdc.firebasestorage.app",
  messagingSenderId: "353184767146",
  appId: "1:353184767146:web:57384f9d7ecd5808e684d3",
  measurementId: "G-EQHV6FSGQC"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

// Add some logging to help debug
console.log('Firebase initialized');

// Helper functions for authentication
const createUserDocument = async (user, additionalData = {}) => {
  if (!user) return;

  const userRef = doc(db, 'users', user.uid);
  const snapshot = await getDoc(userRef);

  if (!snapshot.exists()) {
    const { email } = user;
    const createdAt = new Date();

    try {
      await setDoc(userRef, {
        email,
        createdAt,
        ...additionalData
      }, { merge: true });
      console.log('User document created successfully');
      return userRef;
    } catch (error) {
      console.error('Error creating user document', error);
    }
  }

  return userRef;
};

// Export everything at once
export { auth, db, createUserDocument }; 